import AuthLayout from "@/layout/auth/AuthLayout.vue";

export default [
  {
    path: "/auth",
    component: AuthLayout,
    children: [
      {
        path: "login",
        name: "login",
        component: () =>
          import(
            /* webpackChunkName: "system" */ "@/views/backoffice/system/LoginView.vue"
          ),
      },
      {
        path: "register",
        name: "register",
        component: () =>
          import(
            /* webpackChunkName: "system" */ "@/views/system/RegisterView.vue"
          ),
      },
      {
        path: "forgot-password",
        name: "forgot-password",
        component: () =>
          import(
            /* webpackChunkName: "system" */ "@/views/system/ForgotPasswordView.vue"
          ),
      },
      {
        path: "lock-screen",
        name: "lock-screen",
        component: () =>
          import(
            /* webpackChunkName: "system" */ "@/views/system/ScreenLockedView.vue"
          ),
      },
      {
        path: "new-password",
        name: "new-password",
        component: () =>
          import(
            /* webpackChunkName: "system" */ "@/views/system/CreateNewPasswordView.vue"
          ),
      },
      {
        path: "verification",
        name: "verification",
        component: () =>
          import(
            /* webpackChunkName: "system" */ "@/views/system/VerificationView.vue"
          ),
      },
      {
        path: "oops",
        name: "oops",
        component: () =>
          import(
            /* webpackChunkName: "system" */ "@/views/system/OopsView.vue"
          ),
      },
      {
        path: "access-denied",
        name: "access-denied",
        component: () =>
          import(
            /* webpackChunkName: "system" */ "@/views/system/AccessDeniedView.vue"
          ),
      },
      {
        path: "callback",
        name: "oauth-callback",
        component: () =>
          import(
            /* webpackChunkName: "system" */ "@/views/backoffice/system/OAuthCallbackView.vue"
          ),
      },
    ],
  },
];
